import useFormSubmit from "@/hooks/useFormSubmit";
import { categories } from "@/mocks/events";

const FORM_ID = "dah99kjoh653ivfvnp0g";
const SUBMIT_ADDR = "https://readdy.ai/api/form/dah99kjoh653ivfvnp0g";

export default function SubscribeForm() {
  const { status, message, handleSubmit } = useFormSubmit(
    SUBMIT_ADDR,
    "订阅成功，最新爆料进展会优先推送给你。"
  );

  return (
    <form
      id={FORM_ID}
      data-readdy-form
      onSubmit={handleSubmit}
      noValidate
      className="w-full"
    >
      <div className="flex flex-col gap-3">
        <div className="flex flex-col sm:flex-row gap-3">
          <label className="flex-1 flex flex-col gap-1.5">
            <span className="text-xs text-background-300/85">邮箱地址</span>
            <input
              type="email"
              name="email"
              required
              autoComplete="email"
              placeholder="you@example.com"
              className="h-11 px-3.5 rounded-md bg-foreground-900 border border-foreground-700 text-sm text-background-50 placeholder:text-foreground-400 focus:outline-none focus:border-accent-500"
            />
          </label>
          <label className="flex flex-col gap-1.5 sm:w-52">
            <span className="text-xs text-background-300/85">关注方向</span>
            <select
              name="topic"
              defaultValue="consumer"
              className="h-11 px-3 rounded-md bg-foreground-900 border border-foreground-700 text-sm text-background-50 focus:outline-none focus:border-accent-500 cursor-pointer"
            >
              {categories.map((cat) => (
                <option key={cat.slug} value={cat.slug}>
                  {cat.name}
                </option>
              ))}
            </select>
          </label>
        </div>
        <input
          type="text"
          name="website_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
          className="form-aux-note"
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="h-11 inline-flex items-center justify-center gap-2 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
        >
          {status === "loading" ? (
            <i className="ri-loader-4-line animate-spin" />
          ) : (
            <i className="ri-notification-3-line" />
          )}
          订阅爆料提醒
        </button>
        {status === "success" ? (
          <p className="text-sm text-accent-400 inline-flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line" />
            {message}
          </p>
        ) : null}
        {status === "error" ? (
          <p className="text-sm text-primary-300 inline-flex items-center gap-1.5">
            <i className="ri-error-warning-line" />
            {message}
          </p>
        ) : null}
      </div>
    </form>
  );
}